import { createContext, useEffect, useState } from "react";

export const ThemeContext = createContext();

export const THEME_MAP = {
  theme01: {
    bg: "var(--theme01Background)",
    side: "var(--ebony)",
    name: "Retro Wave",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
  },
  theme02: {
    bg: "var(--theme02Background)",
    side: "var(--ebony)",
    name: "Deep Ocean to Beach",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
  },
  theme03: {
    bg: "var(--theme03Background)",
    side: "var(--creme)",
    name: "Nexark Theme",
		color: "#000",
		colorInfo: "forestgreen",
		colorSwitch: "var(--creme)"
  },
  theme04: {
    bg: "var(--theme04Background)",
    side: "var(--creme)",
    name: "Minzapfel",
		color: "#000",
		colorInfo: "forestgreen",
		colorSwitch: "var(--creme)"
  },
  theme05: {
    bg: "var(--theme05Background)",
    side: "var(--creme)",
    name: "Zitrus Scherbet",
		color: "#000",
		colorInfo: "forestgreen",
		colorSwitch: "var(--creme)"
  },
  theme06: {
    bg: "var(--theme06Background)",
    side: "var(--creme)",
    name: "Retro Regenwolke",
		color: "#000",
		colorInfo: "forestgreen",
		colorSwitch: "var(--creme)"
  },
  theme07: {
    bg: "var(--theme07Background)",
    side: "var(--creme)",
    name: "Hanami",
		color: "#000",
		colorInfo: "forestgreen",
		colorSwitch: "var(--creme)"
  },
  theme08: {
    bg: "var(--theme08Background)",
    side: "var(--creme)",
    name: "Sonnenaufgang",
		color: "#000",
		colorInfo: "forestgreen",
		colorSwitch: "var(--creme)"
  },
  theme09: {
    bg: "var(--theme09Background)",
    side: "var(--creme)",
    name: "Zuckerwatte",
		color: "#000",
		colorInfo: "forestgreen",
		colorSwitch: "var(--creme)"
  },
  theme10: {
    bg: "var(--theme10Background)",
    side: "var(--creme)",
    name: "Lofi Vibes",
		color: "#000",
		colorInfo: "forestgreen",
		colorSwitch: "var(--creme)"
  },
  theme11: {
    bg: "var(--theme11Background)",
    side: "var(--creme)",
    name: "Wüsten Khaki",
		color: "#000",
		colorInfo: "forestgreen",
		colorSwitch: "var(--creme)"
  },
  theme12: {
    bg: "var(--theme12Background)",
    side: "var(--ebony)",
    name: "Sonnenuntergang",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
  },
  theme13: {
    bg: "var(--theme13Background)",
    side: "var(--ebony)",
    name: "Chroma Glow",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
  },
  theme14: {
    bg: "var(--theme14Background)",
    side: "var(--ebony)",
    name: "Wald",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
  },
  theme15: {
    bg: "var(--theme15Background)",
    side: "var(--ebony)",
    name: "Crimson Moon",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
  },
  theme16: {
    bg: "var(--theme16Background)",
    side: "var(--ebony)",
    name: "Mitternächtliches Blauolett",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
  },
  theme17: {
    bg: "var(--theme17Background)",
    side: "var(--ebony)",
    name: "Mars",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
  },
  theme18: {
    bg: "var(--theme18Background)",
    side: "var(--ebony)",
    name: "Dämmerung",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
  },
  theme19: {
    bg: "var(--theme19Background)",
    side: "var(--ebony)",
    name: "Unter dem Meer",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
  },
  theme20: {
    bg: "var(--theme20Background)",
    side: "var(--ebony)",
    name: "Retro Sturm",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
  },
  theme21: {
    bg: "var(--theme21Background)",
    side: "var(--ebony)",
    name: "Neonnächte",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
  },
  theme22: {
    bg: "var(--theme22Background)",
    side: "var(--ebony)",
    name: "Erdbeerlimonade",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
  },
  theme23: {
    bg: "var(--theme23Background)",
    side: "var(--ebony)",
    name: "Aurora",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
  },
  theme24: {
    bg: "var(--theme24Background)",
    side: "var(--ebony)",
    name: "Sepia",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
  },
  theme25: {
    bg: "var(--theme25Background)",
    side: "var(--ebony)",
    name: "Blauolette Dämmerung",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
  },
	theme90: {
    bg: "var(--theme90Background)",
    side: "var(--ebony)",
    name: "Dark Mode",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
	},
	theme91: {
    bg: "var(--theme91Background)",
    side: "var(--creme)",
    name: "Light Mode",
		color: "#000",
		colorInfo: "forestgreen",
		colorSwitch: "var(--creme)"
	},
	theme92: {
    bg: "var(--theme92Background)",
    side: "var(--ebony)",
    name: "Wyvern Blue",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
	},
	theme93: {
    bg: "var(--theme93Background)",
    side: "var(--ebony)",
    name: "Dark Navy",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
	},
	theme94: {
    bg: "var(--theme94Background)",
    side: "var(--creme)",
    name: "Gift Grün",
		color: "#000",
		colorInfo: "forestgreen",
		colorSwitch: "var(--creme)"
	},
	theme95: {
    bg: "var(--theme95Background)",
    side: "var(--ebony)",
    name: "Kiwi",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
	},
	theme96: {
    bg: "var(--theme96Background)",
    side: "var(--ebony)",
    name: "Magenta Kirsche",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
	},
	theme97: {
    bg: "var(--theme97Background)",
    side: "var(--ebony)",
    name: "Kastanie",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
	},
	theme98: {
    bg: "var(--theme98Background)",
    side: "var(--ebony)",
    name: "Black Mode",
		color: "#fff",
		colorInfo: "greenyellow",
		colorSwitch: "var(--ebony)"
  },
  theme99: {
    bg: "var(--theme99Background)",
    side: "var(--creme)",
    name: "White Mode",
		color: "#000",
		colorInfo: "forestgreen",
		colorSwitch: "var(--creme)"
  }
};

export const THEME_ARRAY = Object.entries(THEME_MAP).map(([key, value]) => ({
  ...value,
  id: key
}));

export const ThemeContextProvider = ( { children } ) => {
	const [theme, setTheme] = useState(() => localStorage.getItem("theme") || "theme03");
	const [isThemeMenuOpen, setIsThemeMenuOpen] = useState(false);
	const [isSideStatusOpen, setIsSideStatusOpen] = useState(false);

	useEffect(() => {
		localStorage.setItem("theme", theme);
	}, [theme]);

	useEffect(() => {
		const root = document.querySelector(':root');
    const { bg, side, color, colorInfo, colorSwitch } = THEME_MAP[theme] || THEME_MAP.theme21;

    root.style.setProperty("--background", bg);
    root.style.setProperty("--sidebarBackground", side);
    root.style.setProperty("--color", color);
    root.style.setProperty("--colorSwitch", colorSwitch);
    root.style.setProperty("--colorInfo", colorInfo);
	}, [theme]);

	return (
		<ThemeContext.Provider value={ { theme, setTheme, isThemeMenuOpen, setIsThemeMenuOpen, isSideStatusOpen, setIsSideStatusOpen, THEME_MAP, THEME_ARRAY} }>
			{children}
		</ThemeContext.Provider>
	)
};